import { createAction, props } from "@ngrx/store";
import { IImport } from "src/app/history/models/import";

// Get Imports 
export const getImports = createAction(
    '[Imports] Get Imports'
);

export const getImportsSuccess = createAction(
    '[Imports] Get Imports success', 
    props<{ imports: IImport[] }>()
);

export const getImportsFailure = createAction(
    '[Imports] Get Imports failure',
    props<{error: string}>()
);